import { render, staticRenderFns } from "./billsPaymentCategory.vue?vue&type=template&id=315f3a82"
import script from "./billsPaymentCategory.vue?vue&type=script&lang=js"
export * from "./billsPaymentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports